export const endpointConstants ={
    PING_REQUEST:"ENDPOINT_PING_REQUEST",
    PING_SUCCESS:"ENDPOINT_PING_SUCCESS",
    PING_ERROR:"ENDPOINT_PING_ERROR",

    PARAMS_SUCCESS: "SET_PARAMS_FROM_URL_SUCCESS"
}